import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AccessDenied from './AccessDenied';
import { getEnv } from '../../env-utils';
import RestrictedEnv from '../RestrictedEnv';

const ProtectedRoute = ({ 
  children, 
  allowedRoles = [],
  restrictedEnvs = [],
  fallback = <AccessDenied /> 
}) => {
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [envAllowed, setEnvAllowed] = useState(true); // default true

  // Fetch user role from user info API
  const getRole = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      const role = localStorage.getItem("role");
      setUserRole(role);
      
      // Check if user has access
      if (allowedRoles.length === 0 || allowedRoles.includes(role)) {
        setHasAccess(true);
      } else {
        setHasAccess(false);
      }
    } catch (error) {
      console.error("Error fetching role:", error);
      setHasAccess(false);
    } finally {
      setLoading(false);
    }
  };

  // Check for Env Access for a Route 
  const envProtectedRouteCheck = () => {
    if (restrictedEnvs?.length > 0) {
      const currentEnv = getEnv();
      const isEnvRestricted = restrictedEnvs.some(
        (env) => String(env).toLowerCase() === currentEnv.toLowerCase()
      );
      setEnvAllowed(!isEnvRestricted);
    }
  }

  useEffect(() => {
    envProtectedRouteCheck();
    getRole();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!envAllowed) {
    return <RestrictedEnv />;
  }

  if (!hasAccess) {
    return fallback;
  }

  return children;
};

export default ProtectedRoute; 